"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var review_star_1 = __importDefault(require("~/components/common/review_star"));
var classnames_1 = __importDefault(require("classnames"));
var cv_button_1 = __importDefault(require("~/components/common/ui/cv_button"));
var ClickTransferRecommendedStore = function (props) {
    return (react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-Container" },
        react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-RankIcon" },
            react_1.default.createElement("span", null, props.ranking)),
        react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-Header" },
            react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-Logo" },
                react_1.default.createElement("img", { src: props.logoUrl, alt: props.name, className: "lazyload" })),
            react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-Name_Wrapper" },
                react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-Name" }, props.name),
                react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-Rating" },
                    react_1.default.createElement(review_star_1.default, { rate: props.rating }),
                    react_1.default.createElement("span", { className: "coClickTransferRecommendedStore-Rating_Count" },
                        "(",
                        props.reviewCount,
                        "\u4EF6\u306E\u8A55\u4FA1)")))),
        react_1.default.createElement("div", { className: "coClickTransferRecommendedStore-Description" }, props.description),
        react_1.default.createElement("table", { className: "coClickTransferRecommendedStore-Info" },
            react_1.default.createElement("tbody", null,
                react_1.default.createElement("tr", { className: "coClickTransferRecommendedStore-Info_Row" },
                    react_1.default.createElement("th", { className: "coClickTransferRecommendedStore-Info_Label" }, "\u53D6\u6271\u5546\u54C1"),
                    react_1.default.createElement("td", { className: "coClickTransferRecommendedStore-Info_Value" },
                        props.coCatsText,
                        props.haveOtherCoCats && 'など')),
                react_1.default.createElement("tr", { className: "coClickTransferRecommendedStore-Info_Row" },
                    react_1.default.createElement("th", { className: "coClickTransferRecommendedStore-Info_Label" }, "\u5730\u57DF"),
                    react_1.default.createElement("td", { className: "coClickTransferRecommendedStore-Info_Value" },
                        props.mapsText,
                        props.haveOtherMaps && 'など')),
                react_1.default.createElement("tr", { className: "coClickTransferRecommendedStore-Info_Row" },
                    react_1.default.createElement("th", { className: "coClickTransferRecommendedStore-Info_Label" }, "\u5BFE\u5FDC\u8CB7\u53D6 \u5F62\u5F0F"),
                    react_1.default.createElement("td", { className: "coClickTransferRecommendedStore-Info_Value" }, props.purchaseMethods.map(function (_a, i) {
                        var name = _a[0], condition = _a[1];
                        return (react_1.default.createElement("span", { key: i, className: (0, classnames_1.default)('coClickTransferRecommendedStore-PurchaseMethod', "coClickTransferRecommendedStore-PurchaseMethod-".concat(condition)) }, name));
                    }))),
                react_1.default.createElement("tr", { className: "coClickTransferRecommendedStore-Info_Row" },
                    react_1.default.createElement("th", { className: "coClickTransferRecommendedStore-Info_Label" }, "\u7279\u5FB4"),
                    react_1.default.createElement("td", { className: "coClickTransferRecommendedStore-Info_Value" },
                        "\u9001\u6599: ",
                        props.postage,
                        "\u632F\u8FBC\u624B\u6570\u6599: ",
                        props.transferFee)))),
        react_1.default.createElement(cv_button_1.default, __assign({}, props.cvButtonProps))));
};
exports.default = ClickTransferRecommendedStore;
